var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FlatActionButton',{attrs:{"action":_vm.handleButtonClick,"buttonClass":['btnDefault', 'btnCTA']}},[_vm._v(" "+_vm._s(_vm.buttonText)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }